import { Theme, linearProgressClasses } from "@mui/material";
import { colors } from "../../theme/colors";

export const container = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "95vh",
});

export const bodyContainer = ({ breakpoints }: Theme) => ({
  width: { xs: "100%", sm: "500px" },
  height: "100%",
  background: colors.main_gradient,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: { xs: "50px 50px 0 0", sm: "50px" },
  mt: "90px",
  py: "40px",
  boxShadow: {
    sm: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
  },
});

export const subContainer = ({ breakpoints }: Theme) => ({
  mx: "30px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: { xs: "350px", sm: "440px" },
});

export const titleText = ({ breakpoints }: Theme) => ({
  color: "white",
  fontSize: "24px",
  fontWeight: 600,
  textAlign: "center",
});

export const buttonContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  width: "100%",
  height: "50px",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const backButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  "&:hover": {
    backgroundColor: colors.light_black,
  },
  margin: "100px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const nextButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  margin: "100px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const borderLinearProgress = ({ breakpoints }: Theme) => ({
  height: 15,
  width: "100%",
  mt: 2,
  borderRadius: 7.5,
  borderColor: "black",
  borderWidth: 1,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#E7EAE1",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#DF1545",
  },
});

export const informationContainer = ({ breakpoints }: Theme) => ({
  backgroundColor: "white",
  borderRadius: "25px",
  p: "40px 20px",
  mt: 3,
  maxWidth: "400px",
});

export const itemText = ({ breakpoints }: Theme) => ({
  color: colors.light_black,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "27px",
});

export const disclaimerText = ({ breakpoints }: Theme) => ({
  color: colors.light_black,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "27px",
  mt: 2,
  mb: 4,
});

export const termsText = ({ breakpoints }: Theme) => ({
  color: colors.light_black,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "27px",
  maxWidth: "300px",
  marginRight: 1,
});

export const termsContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  m: "80px 10px",
  maxWidth: "400px",
});

export const disclaimerCheckboxContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  my: 4,
  mx: 1,
  maxWidth: "400px",
});

export const inputItem = ({ breakpoints }: Theme) => ({
  mt: 1,
  borderRadius: 4,
  input: {
    background: "white",
    borderRadius: "6px",
  },
});

export const legalContainer = ({ breakpoints }: Theme) => ({
  width: "95%",
  height: "500px",
  borderRadius: "25px",
  bgcolor: "white",
  p: "20px 10px",
  overflowY: "scroll",
  webkitUserSelect: "none",
  mozUserSelect: "none",
  msUserSelect: "none",
  userSelect: "none",
});

export const checkBoxText = ({ breakpoints }: Theme) => ({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.light_black,
});

export const signButton = ({ breakpoints }: Theme) => ({
  width: "100%",
  color: "white",
  mt: 2,
  mb: 5,
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const legalTextContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mt: 3,
  mb: 3,
});

export const searchContainer = ({ breakpoints }: Theme) => ({
  border: "1px #72B7BC solid",
  borderRadius: 3,
  height: "40px",
  mt: 3,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "0 10px",
  mx: 3,
});

export const searchInput = ({ breakpoints }: Theme) => ({
  width: "100%",
  marginLeft: "10px",
});

export const searchButton = ({ breakpoints }: Theme) => ({
  bgcolor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  fontWeight: 500,
  mt: 3,
  width: "150px",
  height: "50px",
  fontSize: "18px",
  color: "white",
});

export const searchButtonContainer = ({ breakpoints }: Theme) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
});

export const imageContainer = ({ breakpoints }: Theme) => ({
  borderRadius: "25px",
  backgroundColor: "white",
  p: 2,
  height: "200px",
  mt: 1,
});

export const imgButtonContaier = ({ breakpoints }: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});

export const subTitle = ({ breakpoints }: Theme) => ({
  color: colors.main,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "22.4px",
});

export const matchModalContainer = ({ breakpoints }: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
  p: 2,
});
